/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";
import Mail from "@material-ui/icons/Email";
import BusinessCenter from "@material-ui/icons/BusinessCenter";
// core components
import Header from "components/Header/Header.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import LogoFooter from "components/Footer/LogoFooter.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks0.js";
import ProfileLieve from "pages/ProfilePage/Profiles/ProfileLieve.js"
import ProfileElke from "pages/ProfilePage/Profiles/ProfileElke.js"
import ProfileMadou from "pages/ProfilePage/Profiles/ProfileMadou.js"
import ProfileLore from "pages/ProfilePage/Profiles/ProfileLore.js"
import SectionTeam from "pages/LandingPage/Sections/SectionTeam.js";

import profilePageStyle from "assets/jss/material-kit-pro-react/pages/profilePageStyle.js";

const useStyles = makeStyles(profilePageStyle);

export default function ProfilePage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  
  return (
    <div>
      <Header
        brand="Logopedie | Lieve Mutton"
        links={<HeaderLinks dropdownHoverColor="primary" />}
        fixed
        changeColorOnScroll={{
          height: 250,
          color: "dark"
        }}
        color="transparent"
      />
      <Parallax
        image={require("assets/img/examples/office5.jpg")}
        filter="dark"
        className={classes.parallax}
      />
      <div className={classNames(classes.main, classes.mainRaised)}>
        { location.pathname=='/team/lieve' && <ProfileLieve/> }
        { location.pathname=='/team/elke' && <ProfileElke/> }
        { location.pathname=='/team/madou' && <ProfileMadou/> }
        { location.pathname=='/team/lore' && <ProfileLore/> }
      </div>

      <SectionTeam />
      <LogoFooter />
    </div>
  );
}
